import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { createPolymorphicComponent, useMantineTheme, Checkbox as Checkbox$1 } from '@mantine/core';
import { useCheckboxStyle } from './Checkbox.style.js';
import { GUI_GLOBAL_CLASS, GUI_COMP_CSS_VARIABLE_CLASS } from '../../utils/index.js';

var _excluded = ["size", "textSize", "fw", "className", "applyColorVariable", "classNames", "style", "styles", "breakpoints"];
var _Checkbox = function _Checkbox(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 16 : _props$size,
    _props$textSize = props.textSize,
    textSize = _props$textSize === void 0 ? 14 : _props$textSize,
    _props$fw = props.fw,
    fw = _props$fw === void 0 ? 500 : _props$fw,
    className = props.className,
    _props$applyColorVari = props.applyColorVariable,
    applyColorVariable = _props$applyColorVari === void 0 ? false : _props$applyColorVari,
    _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? {} : _props$classNames,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? [] : _props$breakpoints,
    restProps = _objectWithoutProperties(props, _excluded);
  var theme = useMantineTheme();
  var _useCheckboxStyle = useCheckboxStyle({
      size: size,
      textSize: textSize,
      fw: fw,
      hasLabel: !!restProps.label,
      breakpoints: breakpoints
    }, {
      styles: styles,
      classNames: classNames,
      name: 'GateCheckBox'
    }),
    cx = _useCheckboxStyle.cx,
    classes = _useCheckboxStyle.classes;
  return /*#__PURE__*/React__default.createElement(Checkbox$1, _objectSpread2(_objectSpread2({
    transitionDuration: 0,
    dir: theme.dir,
    style: style,
    icon: function icon(_ref) {
      var className = _ref.className;
      return /*#__PURE__*/React__default.createElement("svg", {
        className: className,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React__default.createElement("path", {
        d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
        fill: "currentColor"
      }), /*#__PURE__*/React__default.createElement("path", {
        d: "M3.63794 7.61663L6.74382 10.9166L12.4379 5.41663",
        stroke: "var(--gui-color-icon-8)",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    },
    classNames: classes,
    className: cx(className, GUI_GLOBAL_CLASS, applyColorVariable ? GUI_COMP_CSS_VARIABLE_CLASS : undefined)
  }, restProps), {}, {
    size: "xs"
  }));
};
var CheckboxGroup = function CheckboxGroup(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var theme = useMantineTheme();
  return /*#__PURE__*/React__default.createElement(Checkbox$1.Group, _objectSpread2(_objectSpread2({
    offset: 0
  }, props), {}, {
    dir: theme.dir,
    className: 'gui-font-face ' + className
  }));
};
_Checkbox.Group = CheckboxGroup;
var Checkbox = createPolymorphicComponent(_Checkbox);

export { Checkbox, CheckboxGroup };
//# sourceMappingURL=Checkbox.js.map
